module.exports = __webpack_public_path__ + "static/img/BH.931052ee.svg";